import { render, staticRenderFns } from "./CheckBoxGroupEl.vue?vue&type=template&id=7c127e66&scoped=true&"
import script from "./CheckBoxGroupEl.vue?vue&type=script&lang=ts&"
export * from "./CheckBoxGroupEl.vue?vue&type=script&lang=ts&"
import style0 from "./CheckBoxGroupEl.vue?vue&type=style&index=0&id=7c127e66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c127e66",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
